var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-button" }, [
    _c(
      "div",
      { staticClass: "input" },
      [
        _c("GSInput", {
          attrs: { radius: 9, placeholder: _vm.placeholder },
          on: { changed: _vm.inputChanged }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button" },
      [
        _c("GSButton", {
          attrs: {
            color: "blue",
            text: _vm.text,
            radius: 6,
            disabled: _vm.buttonDisabled
          },
          on: { clicked: _vm.clicked }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75be89a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75be89a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GSInputButton.vue
// module id = null
// module chunks = 